module.exports = __webpack_public_path__ + "static/media/img3.aa14cae0.png";